	@if(header()){
		<mat-list-item class="mat-mdc-list-item-interactive">
			<ogs-m3-icon prefix="fal" icon="eye-slash" class="mat-mdc-list-item-interactive__content"/>
			<span class="menu-item__content">{{"Spalte ausblenden" | translate : "item-label-hide-column" : "shared/table-column-menu"}}</span>
		</mat-list-item>
	}